import { QualtricsCookies } from "../../components/Common/constants";
import { updateQualtricsCookieValue } from "../../utils/QualtricsCookiesUtils";
import { MessageHandlerBase } from "./MessageHandlerBase";
export default class LaunchIvaHandler extends MessageHandlerBase {
    constructor(almeState, setAlmeState, appConfig, apiUtils, ivaSetChatStatus) {
        super(almeState, setAlmeState, appConfig, apiUtils);
        this.ivaSetChatStatus = ivaSetChatStatus;
    }
    handle(message) {
        this.setAlmeState(Object.assign(Object.assign({}, this.almeState), { isOpen: true, launchPointName: message.launchPointName, launchParameter: message.launchParameter }));
        updateQualtricsCookieValue(QualtricsCookies.HadLiveChat, "false");
        updateQualtricsCookieValue(QualtricsCookies.SYFIVA, "CB");
        updateQualtricsCookieValue(QualtricsCookies.IVALaunchType, this.launchType(message));
        this.ivaSetChatStatus.openChat();
    }
    launchType(message) {
        let launchType;
        if (message.launchParameter === "ContactUs" || message.launchParameter === "secureMessaging") {
            launchType = "Proactive";
        }
        else if (message.launchParameter === "PointOfNeed") {
            if (message.launchPointName === "LoginError") {
                launchType = "Proactive";
            }
            else {
                launchType = "Reactive";
            }
        }
        else {
            launchType = "Reactive";
        }
        return this.launchTypeCookieName(launchType);
    }
    launchTypeCookieName(launchTypeName) {
        let launchTypeValue;
        if (launchTypeName === "Reactive") {
            launchTypeValue = "Manual";
        }
        else if (launchTypeName === "Proactive") {
            launchTypeValue = "Auto";
        }
        else {
            launchTypeValue = "Unknown";
        }
        return launchTypeValue;
    }
}
